import { DraggableProvided } from "react-beautiful-dnd";

const grid = 8;
export const getListStyle = (
  isDraggingOver: boolean
): React.CSSProperties | undefined => ({
  background: isDraggingOver ? "white" : "white",
  padding: grid,
  width: "100%",
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
});

export function getStyle({
  provided,
  style = {},
  isDragging,
}: {
  provided: DraggableProvided;
  style?: React.CSSProperties;
  isDragging?: boolean;
}) {
  // If you don't want any spacing between your items
  // then you could just return this.
  // I do a little bit of magic to have some nice visual space
  // between the row items
  const combined = {
    ...style,
    ...provided.draggableProps.style,
  };

  const marginBottom = 0;
  const withSpacing = {
    ...combined,
    height: isDragging
      ? Number(combined.height)
      : Number(combined.height) - marginBottom,
    marginBottom,
  };
  return withSpacing;
}

export function reorder<T>(list: T[], startIndex: number, endIndex: number) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

export const swap = <T,>(arr: T[], idx1: number, idx2: number) => {
  const temp = arr[idx1];
  arr[idx1] = arr[idx2];
  arr[idx2] = temp;
  return arr;
};
